import { ActionReducer } from '@ngrx/store';

/**
 * Logs every dispatched action with the state either side of it, as a
 * collapsed console group. This is deliberately hand-rolled: the store-logger
 * packages are unmaintained and cap their peer range well below the @ngrx in
 * use here, so reach for one and the install fails. Redux DevTools shows the
 * same through `provideStoreDevtools`; this survives a reload as well, and
 * needs no extension.
 */
export function logger<T>(reducer: ActionReducer<T>): ActionReducer<T> {
  return (state, action) => {
    const before = state;
    const after = reducer(state, action);

    console.groupCollapsed(`action ${action.type}`);
    console.log('%cprev state', 'color: #9e9e9e; font-weight: bold', before);
    console.log('%caction', 'color: #03a9f4; font-weight: bold', action);
    console.log('%cnext state', 'color: #4caf50; font-weight: bold', after);
    console.groupEnd();

    return after;
  };
}
